uniform vec2 uFrequency;
uniform float uTime;
uniform vec2 u_resolution;

//attribute vec2 uv;

varying vec2 vUv;
varying float vElevation;
varying vec2 v_resolution;

void main()
{
    v_resolution = u_resolution;
    vUv = uv;
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
//    modelPosition.z += sin(modelPosition.x * 15.0 - uTime*2.0) * 0.1;
   // modelPosition.y += sin(modelPosition.x*700.0- uTime*2.0)*0.1;// * 15.0 - uTime*2.0) * 0.1;
    
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    
    gl_Position = projectedPosition;


    //gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(position, 1.0);
    // vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // float elevation = sin(modelPosition.x * uFrequency.x - uTime) * 0.1;
    // elevation += sin(modelPosition.y * uFrequency.y - uTime) * 0.1;

    // modelPosition.z += elevation;

    // vec4 viewPosition = viewMatrix * modelPosition;
    // vec4 projectedPosition = projectionMatrix * viewPosition;

    // gl_Position = projectedPosition;

    // vUv = uv;
    // vElevation = elevation;
}